// serverUtils.js
// 函数 doserve 用于向服务器发送异步 POST 请求
localStorage.serveraddress = "http://mes.feixuns.com/mes_demo";
import $ from "jquery";
function doserve() {
  // 移除网络错误提示按钮
  $("#neterrtipsbtn").remove();

  // 获取第一个参数作为服务器编号
  const aserverno = arguments[0];
  // 构建请求的 URL
  const aurl = localStorage.serveraddress + "/myserver.ashx";
  // const formid = localStorage.formid;

  // 构建请求参数
  const paramdata = {};
  for (let i = 1; i < arguments.length; i++) {
    // 替换单引号为中文单引号
    const value = arguments[i].replace(/'/g, "’");
    paramdata[`param${i}`] = encodeURI(value);
  }

  // 构建完整的请求数据对象
  // const data = {
  //     serverno: aserverno,
  //     paramslist: localStorage.paramslist,
  //     billno: localStorage.billno,
  //     userno: localStorage.userno,
  //     ...paramdata
  // };

  // 将请求数据转换为 JSON 字符串
  // const data2 = JSON.stringify(data);

  // 构建 URL 参数
  const urlParams = new URLSearchParams();
  urlParams.append("serverno", aserverno);
  urlParams.append("paramslist", localStorage.paramslist);
  urlParams.append("billno", localStorage.billno);
  urlParams.append("auth", localStorage.fxapptoken);
  urlParams.append("userno", localStorage.userno);
  for (let i = 1; i < arguments.length; i++) {
    urlParams.append(`param${i}`, arguments[i]);
  }
  urlParams.append("callback", "?");

  // 开启 CORS 支持
  $.support.cors = true;

  // 返回一个 Promise 对象
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("post", aurl, true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.timeout = 1000000;

    // 处理请求错误
    xhr.onerror = function(e) {
      // const whichappnonettips = "网络连接失败!";
      // $("#" + getformid()).prepend(
      //   `<div id='neterrtipsbtn' style='width: 100%; z-index: 9999; position: fixed;top: 46px;background-color: antiquewhite; text-align: center;color: brown;'>${whichappnonettips}</div>`
      // );
      // // console.log(getformid());
      console.log(e);
      reject(e);
    };

    // 处理请求状态变化
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        let resstr = xhr.responseText;
        resstr = resstr.substring(2, resstr.length - 1);

        try {
          const jsoninfo = JSON.parse(resstr);
          resolve(jsoninfo);
        } catch (parseError) {
          reject(parseError);
        }
      }
    };

    xhr.send(urlParams.toString());
  });
}

// 函数 formatData 用于格式化 doserve 服务返回的数据
function formatData(res) {
  const jsonstr = /<json>(.*?)<\/json>/.exec(res.jsobj);
  // debugger;
  // console.log(JSON.parse(eval(`'${jsonstr[1]}'`)));
  if (jsonstr) {
    try {
      return JSON.parse(eval(`'${jsonstr[1]}'`));
    } catch (parseError) {
      return false;
    }
  }
  return false;
}

// 导出这两个函数，以便其他文件可以引入使用
export { doserve, formatData };
